<div class="ag-bcdfx">
  <div class="ag-row-even">
    <div class="measure-text ag-cell ag-cell-value audit-comment" #measureDiv></div>
  </div>
</div>
<div class="audit-view">
  <div class="audit-popup-body bfx-section-wrapper">
    <ag-grid-angular
      class="ag-bcdfx"
      style="width: 100%; height: 100%"
      enableColResize
      enableSorting
      rowSelection="none"
      (contextmenu)="handleClick($event)"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      [frameworkComponents]="frameworkComponents"
      [showToolPanel]="false"
    >
      [toolPanelSuppressSideButtons]="true" multiSortKey="ctrl"
    </ag-grid-angular>
    <bfx-blotter-column-selector
      [currentLadderBlotter]="blotterInstance"
      bfxElementOnBody
    ></bfx-blotter-column-selector>
  </div>
  <div class="audit-popup-footer">
    <div class="audit-filter-options">
      <p-checkbox
        [(ngModel)]="showTransfer"
        label="Show Transfer/Takes"
        class="bfx-checkbox-bold-sm"
        binary="true"
        (onChange)="refilter()"
      ></p-checkbox>
      <p-checkbox
        [(ngModel)]="showNotification"
        label="Show Notifications"
        class="bfx-checkbox-bold-sm"
        binary="true"
        (onChange)="refilter()"
      ></p-checkbox>
      <p-checkbox
        *ngIf="isBenchmarkClientOrder"
        [(ngModel)]="showRevaluations"
        label="Show Revaluations"
        class="bfx-checkbox-bold-sm"
        binary="true"
        (onChange)="refilter()"
      ></p-checkbox>
      <p-checkbox
        *ngIf="!isBenchmarkAlgoOrder && !isBenchmarkOrder"
        [(ngModel)]="showTriggered"
        label="Show Triggers"
        class="bfx-checkbox-bold-sm"
        binary="true"
        (onChange)="refilter()"
      ></p-checkbox>
    </div>
    <div class="flex-spacer"></div>
    <div>
      <button
        *ngIf="true == canExport"
        class="bfx-button-primary"
        type="button"
        (click)="actionExport_copyToClipboard()"
      >
        Copy to Clipboard
      </button>
    </div>
  </div>
</div>
